import { FontConfig } from "../types"

export const BODY_SM_CONFIG: FontConfig = {
  title: "BODY/sm",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 12, tw: "text-[12px]" },
    lineHeight: { px: 20, tw: "leading-[20px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 13, tw: "text-[13px]" },
    lineHeight: { px: 20, tw: "leading-[20px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 16, tw: "text-[16px]" },
    lineHeight: { px: 21, tw: "leading-[21px]" },
  },
}
